var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-simple-table',{attrs:{"dense":""}},[(_vm.value)?_c('tbody',[_c('tr',[_c('th',[_vm._v("Name")]),_c('td',[_vm._v(_vm._s(_vm.value.name))])]),_c('tr',[_c('th',[_vm._v("Code")]),_c('td',[_vm._v(_vm._s(_vm.value.code))])]),_c('tr',[_c('th',[_vm._v("Description")]),_c('td',[_vm._v(_vm._s(_vm.value.description))])])]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }